import React from 'react';

import './variables.css';
import './global.css';
import Navigation from './navigation';
import Footer from './footer';
import PaintGoalWidget from './paint-goal-widget';

class Template extends React.Component {
  render() {
    const { children } = this.props;

    return (
      <>
        <Navigation />
        <main style={{ position: 'relative' }}>{children}</main>
        <Footer />
        <PaintGoalWidget year={new Date().getFullYear()} />
      </>
    );
  }
}

export default Template;
